import { useNavigate } from 'react-router-dom';

export default function Services() {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'Hasar Danışmanlığı',
      description: 'Profesyonel hasar çözüm ve onarım hizmetleri. Sigorta paketlerinde tam destek.',
      link: '/blog/hasar-danismanligi-kaza-onarimi',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Motor Rektifiye',
      description: 'Uzman kadromuzla motor revizyonu ve rektifiye işlemleri. Garantili hizmet.',
      link: '/blog/motor-rektifiye-mekanik-tamir',
    },
    {
      icon: 'ri-tools-line',
      title: 'Şanzıman Tamir',
      description: 'Otomatik ve manuel şanzıman tamiri. DSG ve CVT uzmanlığı.',
      link: '/blog/sanziman-tamir-bakim',
    },
    {
      icon: 'ri-cpu-line',
      title: 'DR.ECU Yazılım',
      description: 'Yetkili bayi yazılım hizmetleri. Chip tuning ve performans optimizasyonu.',
      link: '/blog/drecu-yazilim-hizmetleri',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Araç Check-Up',
      description: '150+ kontrol noktası ile kapsamlı araç kontrolü. E-karne sistemi.',
      link: '/blog/arac-checkup-periyodik-kontrol',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Arıza Teşhis',
      description: 'Son teknoloji teşhis ekipmanları ile elektronik arıza tespiti.',
      link: '/blog/ariza-teshis-elektronik-sistem',
    },
  ];

  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-sans text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-3 sm:mb-4">
            Hizmetlerimiz
          </h2>
          <p className="font-sans text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            Üst segment araçlar için özel hizmet anlayışı
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => navigate(service.link)}
              className="group bg-white border border-gray-200 p-6 sm:p-8 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${service.icon} text-3xl sm:text-4xl text-black group-hover:text-accent-gold transition-colors`}></i>
              </div>
              <h3 className="font-sans text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                {service.title}
              </h3>
              <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed mb-4 sm:mb-6">
                {service.description}
              </p>
              <div className="flex items-center text-black group-hover:text-accent-gold transition-colors">
                <span className="font-sans text-xs sm:text-sm font-medium tracking-wide">DETAYLI BİLGİ</span>
                <i className="ri-arrow-right-line ml-2 text-base sm:text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}